import { useQuery } from '@tanstack/react-query';
import { useSessionStore } from '@/entities/session';
import { getPaidInvoices } from '../requests';
import type { PaidInvoicesParams } from '../types';

const PAID_INVOICES_QUERY_KEY = 'paid-invoices';

const usePaidInvoices = (params: PaidInvoicesParams) => {
  const { session } = useSessionStore();

  return useQuery({
    queryKey: [PAID_INVOICES_QUERY_KEY, session?.userId, params],
    queryFn: () => getPaidInvoices(params, { throwOnError: true }),
  });
};

export { usePaidInvoices, PAID_INVOICES_QUERY_KEY };
